import { render, staticRenderFns } from "./OrderLinkToJsonButton.vue?vue&type=template&id=2c5655fc&"
import script from "./OrderLinkToJsonButton.vue?vue&type=script&lang=js&"
export * from "./OrderLinkToJsonButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports